import { render, staticRenderFns } from "./CheckboxTable.vue?vue&type=template&id=60184c95&"
import script from "./CheckboxTable.vue?vue&type=script&lang=js&"
export * from "./CheckboxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports